import React from "react";
import "./WmsAlert.scss";

interface WmsAlertProps {
    type?: "warning" | "error" | "success" | "info";
    title: string;
    description?: string;
    icon?: string;
    width?: string;
    className?: string;
}

const WmsAlert: React.FC<WmsAlertProps> = ({
    type = "warning",
    title,
    description,
    icon,
    width = "100%",
    className = "",
}) => {
    const getDefaultIcon = () => {
        if (type === "warning") {
            return "fa-triangle-exclamation";
        } else if (type === "error") {
            return "fa-circle-exclamation";
        } else if (type === "success") {
            return "fa-circle-check";
        } else if (type === "info") {
            return "fa-circle-info";
        } else {
            return "fa-triangle-exclamation";
        }
    };

    const alertIcon = icon || getDefaultIcon();

    return (
        <div className={`wms-alert wms-alert-${type} ${className}`} style={{ width }}>
            <div className="wms-alert-icon-container">
                <div className="wms-alert-fa-icon">
                    <i className={`fas ${alertIcon} wms-alert-icon`}></i>
                </div>
            </div>

            <div className="wms-alert-text">
                <div className="wms-alert-title">{title}</div>
                {description && <div className="wms-alert-description">{description}</div>}
            </div>
        </div>
    );
};

export default WmsAlert;
